
import { Modal, ModalBody, ModalHeader } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { ISubscriptionManagementResources } from '../subscription-management.props.autogenerated';

export interface ISubscriptionConfirmationComponent {
    isOpen: boolean;
    resources: ISubscriptionManagementResources;
    onAccept(): void;
    onDeny(): void;
}

/**
 * modal utility component for subscription management
 */
export class SubscriptionConfirmationComponent extends React.Component<ISubscriptionConfirmationComponent> {

    public render(): JSX.Element {

        const { subManagement_acceptConfirmation, subManagement_cancelConfirmation } = this.props.resources;

        return (
            <Modal
                autoFocus={true}
                fade={true}
                isOpen={this.props.isOpen}
                horizontalPosition='center'
                verticalPosition='center'
                zIndex={1000}
                toggle={this.props.onDeny}
                applicationNode='rsg-root'
                modalClassName='subscription-management-confirm-modal'
            >
                <ModalHeader toggle={this.props.onDeny} />
                <ModalBody>
                    <div className='subscription-management-confirm-modal-content'>{this.props.children}</div>
                    <div className='subscription-management-confirm-modal-buttons'>
                        <button className='subscription-management-confirm-modal-accept' onClick={this.props.onAccept}>{subManagement_acceptConfirmation}</button>
                        <button className='subscription-management-confirm-modal-cancel' onClick={this.props.onDeny} >{subManagement_cancelConfirmation}</button>
                    </div>
                </ModalBody>
            </Modal>
        );
    }
}